import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { stringify } from 'querystring';

@Component({
  selector: 'app-book-isbn',
  templateUrl: './book-isbn.component.html',
  styleUrls: ['./book-isbn.component.css']
})
export class BookISBNComponent implements OnInit {
  ItemType:[];
  Submitted:boolean=false;
  BookISBNList:any;



  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
 
  
  numberOfPages  () {

      this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage  () {
      this.currentPage = this.currentPage + 1;

  }

  pageSizes  () {
      this.currentPage = 1;
      this.recordCount = 0;
      this.totalPages = 0;

  }
  FilterModel = {

      CurrentIndex: 0,
      PageSize:20,
  }
  BookISBNModel = {
      CurrentIndex: 0,
      FromAccNo: '',
      ToAccNo: '',
      Publication: '',
      PageSize:20,
      FromDate: '',
      ToDate: '',
      IsStaff: 0,
      IsStudent: 0,
      ItemTypeID: 0,
      BookTitleID: 0,
      BookGroupID: 0,
      AuthorID: 0,
      AuthorName: '',
      Medium: '',
      PublicationID: 0,
      CallNo:'',
      Subject:'',
      BookTitle:''

  };
  GetItemType  () {
    
     this.lookupservice.GetLookupsList('ItemType','').subscribe( (data:any) =>{
          this.ItemType = data.LookupItems;
          
      });
  };
  ClearFilter  () {

      this.BookISBNModel.ItemTypeID = 0;
      this.BookISBNModel.BookTitle = '';
      this.BookISBNModel.AuthorName = '',
      this.BookISBNModel.Publication = ''; 
      this.BookISBNModel.FromAccNo = '';
      this.BookISBNModel.ToAccNo = '';
      this.BookISBNModel.CallNo = '';
      this.BookISBNModel.Subject = '';
  }
PrintBarCode  () {

      var url = "../../../../App/Library/BookISBN/PrintBarCodeLabel.html?PrintType=BarCodeLabel&ItemTypeID=" + this.BookISBNModel.ItemTypeID + "&AuthorName=" + this.BookISBNModel.AuthorName + "&BookTitle=" + this.BookISBNModel.BookTitle
      + "&Publication=" + this.BookISBNModel.Publication + "&FromAccNo=" + this.BookISBNModel.FromAccNo + "&ToAccNo=" + this.BookISBNModel.ToAccNo;
      this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  };

  Reservationloading = false;
 
  ReservationModel = {
    BookSerialNo:'',
    LibCardNo:'',
  };

  SetAccNo (item) {

      this.ReservationModel.BookSerialNo = item.BookSerialNo

  }

  SaveBookUnreserved (item) {
   
      var retVal = confirm("Are you sure you want to Unreserved this book");
      if (retVal == true) {
          this.ReservationModel.BookSerialNo = item.BookSerialNo
          this.spinnerService.show();
          this.libraryservice.SaveBookUnreserved(JSON.stringify(this.ReservationModel)).subscribe( (response:any)=> {
            this.spinnerService.hide();

              this.GetBookISBN();
              this.globalHelper.CheckActionStatus(response);
          });
      }
    }

  SaveBookReservation  () {
   
    this.spinnerService.show();
      this.libraryservice.SaveBookReservation(JSON.stringify(this.ReservationModel)).subscribe( (response:any)=> {
        this.spinnerService.hide();
        // ('#academic').click();
          this.GetBookISBN();
          this.globalHelper.CheckActionStatus(response);
      });
  };

  SearchBookISBN  () {
      this.currentPage = 1;
      this.GetBookISBN();
  }
  GetBookISBN  () {
    
    this.spinnerService.show();
      this.BookISBNModel.CurrentIndex = this.currentPage;
      this.BookISBNModel.PageSize = this.pageSize;
    
      this.libraryservice.GetBookISBN(JSON.stringify(this.BookISBNModel)).subscribe( (response:any)=> {
         this.BookISBNList = response.BookISBNList;
          
          
          if (this.BookISBNList != null && response.BookISBNList.length > 0) {
              this.recordCount = this.BookISBNList[0].RecordCount;
          }

          this.numberOfPages();
          this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(response);
      });
  };

  ngOnInit() {
    this.GetItemType();
  }

}
